import {graphql} from 'react-relay'
import {useFragment} from 'react-relay/hooks'

import {LABELS} from '../constants'
import {createIssueEventExternalUrl} from '../utils/urls'
import type {MilestonedEvent$key} from './__generated__/MilestonedEvent.graphql'
import {getWrappedMilestoneLink} from './DemilestonedEvent'
import {TimelineRow} from './row/TimelineRow'

type MilestonedEventProps = {
  queryRef: MilestonedEvent$key
  issueUrl: string
  highlightedEventId?: string
  refAttribute?: React.MutableRefObject<HTMLDivElement | null>
}

export function MilestonedEvent({
  queryRef,
  issueUrl,
  highlightedEventId,
  refAttribute,
}: MilestonedEventProps): JSX.Element {
  const {actor, createdAt, milestoneTitle, milestone, databaseId} = useFragment(
    graphql`
      fragment MilestonedEvent on MilestonedEvent {
        databaseId
        createdAt
        actor {
          ...EventActor
          ...EventActorAvatarItemBadge
        }
        milestoneTitle
        milestone {
          url
        }
      }
    `,
    queryRef,
  )
  const highlighted = String(databaseId) === highlightedEventId

  return (
    <TimelineRow
      highlighted={highlighted}
      refAttribute={refAttribute}
      actor={actor}
      createdAt={createdAt}
      actorAvatar={actor}
      deepLinkUrl={createIssueEventExternalUrl(issueUrl, databaseId)}
    >
      <>
        {LABELS.timeline.addedToMilestone} {getWrappedMilestoneLink(milestone?.url, milestoneTitle)}
        {LABELS.timeline.milestone}{' '}
      </>
    </TimelineRow>
  )
}

try{ MilestonedEvent.displayName ||= 'MilestonedEvent' } catch {}